//
//
//
//
//
//
//
//
//

import MainLayout from './Main'
import auth from '../auth'
import bar3 from '../data/bar'

export default {
  data () {
    let legend_data = [
      '1','2','3','4','5'
    ]
    let series_data = [
      {"value":"154","name":"1"},{"value":"576","name":"2"},{"value":"70","name":"3"},{"value":"12","name":"4"},{"value":"2","name":"5"}
    ]

    return {

      openid: '',
      token: '',
      community: '',
      respData: {},
      bar3,

      line:{
        title: {
          text: '成交价格',
          left: 'center',
          textStyle: {
            color: '#999'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: 25,
          data:['phpdata','北京']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            dataZoom: {yAxisIndex: 'none'},
            dataView: {readOnly: false},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name:'phpdata',
            type:'line',
            data:['phpdata']
          },
          {
            name:'北京',
            type:'line',
            data:['phpdata']
          }
        ]
      },

      bar2:{

        baseOption:{
          title: {
              text: '成交数量',
              subtext: '数据来自网络'
              /*left: 'left',
              textStyle: {
                  color: '#999'
              }*/
          },
          tooltip: {
              trigger: 'axis'
          },
          legend: {
              //top: 25,
              orient: 'vertical',
              data:['phpdata','北京']
          },
          grid: {
              show: true,
              left: '1%',
              right: '1%',
              //bottom: '3%',
              containLabel: true
          },
          toolbox: {
              feature: {
                dataZoom: {yAxisIndex: 'none'},
                dataView: {readOnly: false},
                saveAsImage: {}
              }
          },
          xAxis: {
            type: 'value',
            scale: true,
            position:'top'
          },
          yAxis: {
            type: 'category',
            inverse: true,
            boundaryGap: true,
            data: ['phpdata']
          },
          series: [
            {
              name:'phpdata',
              type:'bar',
              data:['phpdata'],
              markPoint: {
                data: [
                  {type: 'max', name: '最大值'},
                  {type: 'min', name: '最小值'}
                ]
              },
              markLine: {
                data: [
                  {type: 'average', name: '平均值'}
                ]
              }
            },
            {
                name:'北京',
                type:'bar',
                data:['phpdata']
            }
          ]
        },
         media: [
            {
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '1%',
                  containLabel: true
                }
              }
            },
            {
              query: {
                  maxWidth: 320              // 当容器宽度小于 500 时。
              },
              option: {
                grid: {
                  show: true,
                  left: '1%',
                  right: '1%',
                  bottom: '30%',
                  containLabel: true
                }
              }
            }
        ]

      },
      bar:{
        title: {
            text: '成交数量',
            subtext: '数据来自网络'
            /*left: 'left',
            textStyle: {
                color: '#999'
            }*/
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            //top: 25,
            orient: 'vertical',
            data:['phpdata','北京']
        },
        grid: {
            show: true,
            left: '1%',
            right: '1%',
            //bottom: '3%',
            containLabel: true
        },
        toolbox: {
            feature: {
              dataZoom: {yAxisIndex: 'none'},
              dataView: {readOnly: false},
              saveAsImage: {}
            }
        },
        xAxis: {
          type: 'value',
          scale: true,
          position:'top'
        },
        yAxis: {
          type: 'category',
          inverse: true,
          boundaryGap: true,
          data: ['phpdata']
        },
        series: [
          {
            name:'phpdata',
            type:'bar',
            data:['phpdata'],
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'}
              ]
            }
          },
          {
              name:'北京',
              type:'bar',
              data:['phpdata']
          }
        ]
      },


    }

  },
  methods: {
    load() {
      console.log("this.respData:%o", this.respData)
      let count = this.respData.count
      let bj_count = this.respData.bj_count
      let brief = this.respData.brief

      //let data = this.respData.bj_bedroom
      console.log("updateChart...count:%o", count)
      var at=[]
      var as=[]
      for (let key in count) {
        let value = count[key]
        at.push(key)
        as.push(value)
        // console.log("key:%s, value:%s", key, value)
      }

      console.log("updateChart...bj_count:%o", bj_count)
      var bat=[]
      var bas=[]
      for (let key in bj_count) {
        let value = bj_count[key]
        bat.push(key)
        bas.push(value)
        // console.log("key:%s, value:%s", key, value)
      }

      let n = []
      n.push(brief.name)
      n.push("北京")
      console.log("n:%o", n)
      let asyncData = {
        name: n,
        categories: at,
        data: as
      }

      let bjasyncData = {
        categories: bat,
        data: bas
      }

      console.log("load...asyncData:%o", asyncData.data)
      console.log("load...bjasyncData:%o", bjasyncData.data)

      this.$refs.bar.mergeOptions({
        legend: {
            //top: 25,
            data:asyncData.name
        },
         yAxis: {
            data: asyncData.categories
        },
        series: [
          {
            name: asyncData.name[0],
            data: asyncData.data
          },
          {
            name: "北京",
            data: bjasyncData.data
          }
        ]
      })
    },
    reqApiData: function(openid, token, community){
      console.log("openid:%s, token:%s, community:%s", openid, token,community)
      let reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal'
      var url = reqHouseAreaUrl
      let req_data = {openid:openid, token:token, community:community}
      console.log("reqHouseArea url:%s", url);
      this.$http.post(url, req_data).then((response) => {
        console.log("PASS! response:%o", response);
        console.log("status:%s", response.status);
        console.log("statusText:%s", response.statusText);
        console.log("Expires: %s", response.headers.get('Expires'));
        console.log("body: %o", response.body);
        this.respData = response.body.data
        console.log("coin: %d", response.body.data.coin)
        auth.setCoins(response.body.data.coin)
        this.load()
      }, (response) => {
        // error callback
        console.error("FAIL!!! response:%o", response);
      });
    },
    updateChart: function(data){
      data = [{"count":"154","bedroom":"1"},{"count":"576","bedroom":"2"},{"count":"70","bedroom":"3"},{"count":"12","bedroom":"4"},{"count":"2","bedroom":"5"}]
      console.log("updateChart...data:%o", data)
      var at = new Array()
      var as = new Array()
      let asyncData = {
        categories: at,
        data: as
      }

      for (var x in data)
      {
        console.log("x:%s, data:%o", x, data[x])
        var tn = data[x]["bedroom"] + "居室"
        at.push(tn)
        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}'
        as.push(ass)
      }
      console.log("at:%o, as:%o", at, as)
      console.log("this.$refs.pie:%o", this.$refs.pie)
      return asyncData
    }
  },
  beforeCreate (){
    console.log("beforeCreate...")
  },
  created (){
    console.log("created...")
    console.log('get openid:%s', auth.getOpenid())
    console.log('get community:%s', auth.getCm())
    console.log('get token:%s', auth.getToken())
    console.log("route.query.cm:%s",this.$route.query.cm)
    if(typeof(this.$route.query.cm)!= "undefined"){
      let cm = this.$route.query.cm
      console.log("cm:%s", cm)
      auth.setCm(cm);
    }
    this.openid = auth.getOpenid()
    this.token = auth.getToken()
    this.community = auth.getCm()
    console.log("community:%s", this.community)
    this.reqApiData(this.openid, this.token, this.community)
  },
  beforeMount (){
    console.log("beforeMount...")
  },
  mounted (){
    console.log("mounted...")
    //let res = this.updateChart(null)
    //console.log("res:%o", res)

  },
  beforeUpdate (){
    console.log("beforeUpdate...")
  },
  updated (){
    console.log("updated...")
  },
  activated (){
    console.log("activated...")
  },
  deactivated (){
    console.log("deactivated...")
  },
  beforeDestory (){
    console.log("beforeDestory...")
  },
  destroyed (){
    console.log("destroyed...")
  },
  components: {
    MainLayout
  }

}



// WEBPACK FOOTER //
// ./src/components/DetailQty.vue